import { useEffect } from 'react';

import env from '@config/env';

import { router } from '../router';

export const useYandexMetrika = () => {
  useEffect(() => {
    const id = env.YANDEX_METRIKA_ID;
    if (!id) return;

    ((m: any, e: Document, t: string, r: string, i: string, k?: HTMLScriptElement, a?: Element) => {
      m[i] =
        m[i] || ((...args: any[]) => {
          (m[i].a = m[i].a || []).push(args);
        });
      m[i].l = Date.now();
      k = e.createElement(t) as HTMLScriptElement;
      a = e.getElementsByTagName(t)[0];
      k.async = true;
      k.src = r;
      if (a && a.parentNode) {
        a.parentNode.insertBefore(k, a);
      }
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

    window.ym(id, 'init', {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
    });

    window.ym(id, 'hit', router.state.location.pathname + router.state.location.search);

    const unsubscribe = router.subscribe((state) => {
      const url = state.location.pathname + state.location.search;
      window.ym(id, 'hit', url);
    });

    return () => {
      unsubscribe();
    };
  }, []);
};
